import type { NotificacaoItem } from '@/types/notificationBell/types';

/**
 * Para onde vai o clique num aviso do sino da equipe interna. Todo aviso de processo arbitral abre
 * o detalhe da Secretaria, onde está a ação que ele pede (o "Tentar de novo" do fluxo travado por
 * erro vem em destaque no menu). Aviso de outra entidade não tem destino, e a `AdminTopbar` o deixa
 * fora do clique: virar botão só o marcaria como lido.
 *
 * @example rotaDoAvisoDaEquipeInterna({ entityType: 'ProcessoArbitral', entityId: 'p-1', … })
 *   // '/admin-geral/secretaria/processos/p-1'
 */
export function rotaDoAvisoDaEquipeInterna(
  item: Pick<NotificacaoItem, 'entityType' | 'entityId'>,
): string | null {
  if (item.entityType !== 'ProcessoArbitral' || !item.entityId) return null;
  return `/admin-geral/secretaria/processos/${encodeURIComponent(item.entityId)}`;
}
